import orderBy from 'lodash/orderBy';
import values from 'lodash/values';
import get from 'lodash/get';
import find from 'lodash/find';
import moment from 'moment';

const defaultInitialState = {
	columns: {
		date: {
			index: 'date',
			title: 'Date',
			direction: 'desc'
		},
		id: {
			index: 'id',
			title: 'ID',
			direction: 'desc'
		},
		campaign_id: {
			index: 'campaign_id',
			title: 'Campaign ID'
		},
		affiliate: {
			index: 'affiliate',
			title: 'Affiliate'
		},
		offer: {
			index: 'offer',
			title: 'Offer/Offer status'
		},
		payload: {
			index: 'payload',
			title: 'Payload/Validation message'
		},
		type: {
			index: 'type',
			title: 'Type'
		},
		actions: {
			title: 'Actions'
		}
	},
	sortByColumn: {
		index: 'date',
		title: 'Date',
		direction: 'desc'
	},
	pagination: {
		rowsNumber: 20,
		rowsPerPage: 20
	}
};

const createTable = ({
	namespace,
	stateNodeName
}) => {
	// action types
	const SORT_BY_COLUMN = `${namespace}/table-sort-by-column`;
	const SHOW_MORE_ROWS = `${namespace}/table-show-more-rows`;

	const TOGGLE_DETAILS = `${namespace}/toggle-details`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		sortByColumn: columnIndex => ({
			type: SORT_BY_COLUMN,
			payload: columnIndex
		}),

		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		}),

		toggleDetails: rowId => ({
			type: TOGGLE_DETAILS,
			payload: rowId
		})
	};

	// reducers
	const reducers = {
		[SORT_BY_COLUMN]: (state, action) => {
			const { sortByColumn, columns }  = state.table;
			const columnIndex = action.payload;
			const direction = sortByColumn['index'] === columnIndex ?
				sortByColumn.direction === 'desc' ? 'asc' : 'desc' :
				columns[columnIndex].direction;

			return {
				...state,
				table: {
					...state.table,
					sortByColumn: {
						...columns[columnIndex],
						direction
					}
				}
			};
		},

		[SHOW_MORE_ROWS]: state => ({
			...state,
			table: {
				...state.table,
				pagination: {
					...state.table.pagination,
					rowsNumber: state.table.pagination.rowsNumber += state.table.pagination.rowsPerPage
				}
			}
		})
	};

	// selectors
	const selectors = {
		getTable: (state, usePagination) => {
			const { table, data } = state[namespace];
			const rows = data ? sortColumns(data, table.sortByColumn) : [];
			const lists = state.root.lists;

			let modifyRows = rows.map(row => ({
				...row,
				type: getTextFromList(lists['unacceptable-conversion-types'], row['type_id'])
			}));

			return {
				headers: values(table.columns),
				rows: usePagination ? modifyRows : modifyRows.slice(0, table.pagination.rowsNumber),
				sortedColumn: table.sortByColumn,
				rowsNumber: table.pagination.rowsNumber,
				totalRows: rows.length,
				shouldShowPaginationControl: modifyRows.length > table.pagination.rowsNumber
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

// functions
const sortColumns = (rows, sortedColumn) => {
	if (!rows) return null;
	return orderBy(rows, row => {
		const value = row[sortedColumn.index];
		switch (sortedColumn.index) {
			case 'date':
				return  moment(value).valueOf();
			default:
				return value;
		}
	}, sortedColumn.direction);
};

export const getTextFromList = (lists, id) => get(find(lists, { id }), 'text');

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/unacceptable-conversions/index.js